import React, { FC, memo, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Hyperlink from "../Common/Hyperlink";
import { OverflowDetails, PharmaCompany } from "../../typescript/interfaces/data";
import config from "../../config";
import Ellipsis from "../Common/Ellipsis";
import { VisibilityContext } from "../../context";

const useStyles = makeStyles({
  company: {
    display: "block",
  },
  overflow: {
    position: "absolute",
    top: "0px",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
  },
});

type BrandCompanyTDProps = {
  brandCompanies: PharmaCompany[];
  width: number;
  overflow: OverflowDetails;
  rowId: number;
  noLink: boolean;
};

const BrandCompanyTD: FC<BrandCompanyTDProps> = memo(({ brandCompanies, width, overflow, rowId, noLink }) => {
  const classes = useStyles();

  const [visibilityContext] = useContext(VisibilityContext);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    visibilityContext.rowsExpanded.includes(rowId) || visibilityContext.detailPanelsOpen.includes(rowId)
      ? setIsOpen(true)
      : setIsOpen(false);
  }, [visibilityContext]);

  return (
    <div className={overflow.isExpandable && !isOpen ? classes.overflow : ""}>
      {brandCompanies.map(({ id, name }) => (
        <div key={id} className={classes.company}>
          <Hyperlink url={`${config.USER_URL}/Pharma/Company/${id}`} noLink={noLink}>
            <Ellipsis width={width - 25} variant="body2" text={name}>
              {name}
            </Ellipsis>
          </Hyperlink>
        </div>
      ))}
    </div>
  );
});

export default BrandCompanyTD;
